export const DismissReason = Object.freeze({
  cancel: 'cancel',
  backdrop: 'backdrop',
  close: 'close',
  esc: 'esc',
  timer: 'timer'
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/sweetalert2/src/utils/DismissReason.js
// module id = null
// module chunks = 